export const mammoQualityControlArtifactEvaluation = {
    template: require('./mammo-quality-control-artifact-evaluation.html'),
    controller: 'MammoQualityControlArtifactEvaluationController'
};
